import React from "react";
import { Link } from "react-router-dom";
import useSignedIn from "../hooks/useSignedIn";
import YouTubeBlue from "../assets/icons/youtub-blue.png";
import FacebookBlue from "../assets/icons/facebook-blue.png";
import logoFooter from "../assets/footer-logo.png";
import YouTube from "../assets/icons/youtub.svg";
import Facebook from "../assets/icons/facebook.svg";
import UpArrow from "../assets/icons/up-arrow.svg";
import SubscribeArrow from "../assets/icons/subscribe-arrow.svg";

const Footer = () => {
  // Task 149: there is no readable token to test. Subscribed rather than
  // read once, so a session cleared mid-visit updates the footer too.
  const isLoggedIn = useSignedIn();
  // Derived so the copyright doesn't go stale on New Year's Day.
  const currentYear = new Date().getFullYear();
  return (
    <>
    {!isLoggedIn ? (
    <div className="before-login">
      <footer className="">
      <div className="px-3 mx-auto grid grid-cols-1 xl:grid-cols-12 gap-8">
        <div className=" block xl:hidden">
          <div className="col-span-1">
            <img
            src={logoFooter}
            className="w-[100px] "
            alt="footer logo"
          />
          </div>
        </div>
        <div className="xl:col-span-4 lg:col-span-12 order-2 xl:order-1 ">
          <div className=" p-4 xl:p-6 rounded-md xxl:max-w-[400px] xl:max-w-[360px]   xl:h-full lg:h-[200px] md:h-[200px] flex justify-between flex-col" style={{backgroundColor:"#1B365D"}}>
            <h2 className=" heading text-[#CFCDBE]">
              Subscribe to our <br /> newsletter
            </h2>
            <div className="relative mt-4">
              <input
                type="email"
                placeholder="your@email.ru"
                className="w-full bg-transparent text-base font-normal border-b border-white placeholder-white text-white py-1 ps-0 pr-10 rounded-none"
              />
              <img
                src={SubscribeArrow}
                alt="arrow"
                className="absolute right-0 top-1/2 -translate-y-1/2 w-4 h-4"
              />
            </div>
          </div>
        </div>

        {/* Links */}
        <div className="xl:col-span-6 lg:col-span-12 order-1 xl:order-2 grid grid-cols-1 md:grid-cols-3 lg:grid-cols-3 xl:grid-cols-3 gap-6 text-sm">
          <div>
            <h6 className="font-semibold mb-2 text-orange-400">Info</h6>
            <ul className="space-y-1">
              <li><a href="about.html">About Us</a></li>
              <li><a href="services.html">Services</a></li>
              <li><a href="blog.html">Blogs</a></li>
              <li><a href="contact.html">Contact Us</a></li>
             <li>
  <Link to="/visa-eligibility">Visa Eligibility</Link>
</li>
            </ul>
          </div>

          <div>
            <h6 className="font-semibold mb-2 text-orange-400">Resources</h6>
            <ul className="space-y-1">
              <li><a href="#">Immigration Forms and Fees</a></li>
              <li><a href="#">Green Cards</a></li>
              <li><a href="#">U.S. Citizenship</a></li>
            </ul>
          </div>

          <div className="hidden xl:block text-right">
            <img
              src={logoFooter}
              alt="footer logo"
              className="inline-block"
            />
          </div>

          <div>
            <h6 className="font-semibold mb-2 text-orange-400">For Individuals</h6>
            <ul className="space-y-1">
              <li><a href="#">Citizenship Application</a></li>
              <li><a href="#">Family Sponsorship</a></li>
              <li><a href="#">Green Card Renewal/Replacement</a></li>
              <li><a href="#">Green Card Conditions Removal</a></li>
              <li><a href="#">Travel Document Application</a></li>
            </ul>
          </div>

          <div>
            <h6 className="font-semibold mb-2 text-orange-400">For Businesses</h6>
            <ul className="space-y-1">
              <li><a href="#">Work Visa</a></li>
              <li><a href="#">Student Visa</a></li>
              <li><a href="#">Work Permit</a></li>
              <li><a href="#">Exchange Visa</a></li>
              <li><a href="#">Intra-Company Transfer</a></li>
              <li className="md:hidden"><a href="#">Extraordinary Ability</a></li>
              <li className="md:hidden"><a href="#">Advanced Degree</a></li>
              <li className="md:hidden"><a href="#">National Interest Waiver</a></li>
              <li className="md:hidden"><a href="#">Skilled/Professional Workers</a></li>
              <li className="md:hidden"><a href="#">Investor Visa</a></li>
            </ul>
          </div>

          <div className="hidden md:block">
            <h6 className="invisible">.</h6>
            <ul className="space-y-1">
              <li><a href="#">Extraordinary Ability</a></li>
              <li><a href="#">Advanced Degree</a></li>
              <li><a href="#">National Interest Waiver</a></li>
              <li><a href="#">Skilled/Professional Workers</a></li>
              <li><a href="#">Investor Visa</a></li>
            </ul>
          </div>
        </div>

        {/* Social and Back to Top */}
        <div className="xl:col-span-2 lg:col-span-12 order-3 flex xl:items-end  lg:items-center items-center justify-between xl:justify-end pe-5">
          <a href="#hero_section" className="me-2  up-arrow">
            <img src={UpArrow} alt="up arrow"  />
          </a>
          <div className="flex xl:flex-col lg:flex-row  social_icons">
            <a href="https://www.facebook.com/" target="_blank" className="lg:me-2 xl:me-0 me-2">
              <img src={Facebook} alt="Facebook"  />
            </a>
            <a href="https://www.instagram.com/accounts/login/?hl=en" target="_blank">
              <img src={YouTube} alt="YouTube" />
            </a>
          </div>
        </div>
      </div>
    </footer>
    <div className="text-[10px] bg-[#131311] text-[#6F6D66] p-4">
      © {currentYear} Let's Get Visa All Rights Reserved
    </div>
    </div>
          ) : (
    <footer className="after-login flex items-center justify-between container-flude bg-[#CED4DA] px-4 md:px-8 text-[12px] text-[#1B365D]">
        © {currentYear} Let's Get Visa All Rights Reserved
          <div className="flex  social_icons">
            <a href="https://www.facebook.com/" target="_blank" className="lg:me-2 xl:me-0 me-2">
              <img src={FacebookBlue} alt="Facebook"  />
            </a> &nbsp; &nbsp;
            <a href="https://www.instagram.com/accounts/login/?hl=en" target="_blank">
              <img src={YouTubeBlue} alt="YouTube" />
            </a>
          </div>
    </footer>
     )}
    </>
  );
};

export default Footer;
